import { Box } from '@mui/material';
import Info from 'components/Info/Info';

export default function Card({ align, children, id, info }: CardProps) {

    return <Box bgcolor="grey.100" borderRadius={4} boxShadow={1} flex={1} id={id} padding={2.5} position="relative" textAlign={align}>
        {info && (
            <Box position="absolute" right={0} top={0} zIndex={1}>
                <Info color="default" popupName={info} />
            </Box>
        )}
        {children}
    </Box>;

}